import { DOCUMENT_KIND } from "@/config/const";

const documentKind = [
  {
    key: DOCUMENT_KIND.IMAGE,
    icon: "ImageIcon",
    name: "画像",
  },
  {
    key: DOCUMENT_KIND.VIDEO,
    icon: "FilmIcon",
    name: "動画",
  },
  {
    key: DOCUMENT_KIND.PDF,
    icon: "FileTextIcon",
    name: "PDF",
  },
  {
    key: DOCUMENT_KIND.WORD,
    icon: "FileTextIcon",
    name: "Word",
  },
  {
    key: DOCUMENT_KIND.EXCEL,
    icon: "FileTextIcon",
    name: "Excel",
  },
  {
    key: DOCUMENT_KIND.POWERPOINT,
    icon: "FileTextIcon",
    name: "PowerPoint",
  },
  {
    key: DOCUMENT_KIND.OTHER,
    icon: "FileIcon",
    name: "その他"
  }
];


const wordMime = ["application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
const excelMime = ["application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"];
const powerpointMime = ["application/vnd.ms-powerpoint", "application/vnd.openxmlformats-officedocument.presentationml.presentation"];


const getKind = (mime) => {
  if (!mime) return DOCUMENT_KIND.OTHER
  if (mime.startsWith('image/')) return DOCUMENT_KIND.IMAGE;
  if (mime.startsWith('video/')) return DOCUMENT_KIND.VIDEO;
  if (mime === "application/pdf") return DOCUMENT_KIND.PDF;
  if (wordMime.findIndex(item => item === mime) !== -1) return DOCUMENT_KIND.WORD;
  if (excelMime.findIndex(item => item === mime) !== -1) return DOCUMENT_KIND.EXCEL;
  if (powerpointMime.findIndex(item => item === mime) !== -1) return DOCUMENT_KIND.POWERPOINT;

  return DOCUMENT_KIND.OTHER
}


import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("enterpriseDocumentManager");

export default {
  data () {
    return {
      scrollbarSettings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30,
      },
    };
  },
  methods: {
    ...mapActions(["getCurrentPath", "existsFile", "existsFolder"]),
    getDocumentMimeName (mime) {
      const key = getKind(mime);
      return documentKind.find(item => item.key === key).name
    },
    getDocumentMimeKind (mime) {
      return getKind(mime)
    },
    getDocumentMimeIcon (mime) {
      const key = getKind(mime);
      return documentKind.find(item => item.key === key).icon;
    },
    validateSlash (payload) {
      if (payload.name.includes("/")) {
        this.$validator.errors.remove(payload.field);
        this.$validator.errors.add({
          field: payload.field,
          msg: `使用できない文字が含まれています`
        })
      }
    },
    async validateExistsFileName (payload) {
      const currentPath = await this.getCurrentPath()
      const exists = await this.existsFile(`${currentPath}${payload.name}`);
      if (!exists) return;
      this.$validator.errors.remove(payload.field);
      this.$validator.errors.add({
        field: payload.field,
        msg: `既に存在するファイル名です`
      })
    },
    async validateExistsFolderName (payload) {
      const currentPath = await this.getCurrentPath()
      const param = {
        name: payload.name,
        path: `${currentPath}`
      }
      const exists = await this.existsFolder(param);
      if (!exists) return;
      this.$validator.errors.remove(payload.field);
      this.$validator.errors.add({
        field: payload.field,
        msg: `既に存在するフォルダ名です`
      })
    },
  }
};
